/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateFolderDto interface.
 */
export function instanceOfUpdateFolderDto(value) {
    return true;
}
export function UpdateFolderDtoFromJSON(json) {
    return UpdateFolderDtoFromJSONTyped(json, false);
}
export function UpdateFolderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'color': json['color'] == null ? undefined : json['color'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'customFolderId': json['customFolderId'] == null ? undefined : json['customFolderId'],
    };
}
export function UpdateFolderDtoToJSON(json) {
    return UpdateFolderDtoToJSONTyped(json, false);
}
export function UpdateFolderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'parentId': value['parentId'],
        'color': value['color'],
        'tags': value['tags'],
        'customFolderId': value['customFolderId'],
    };
}
